export enum AuthCompanyBillingActions {
  REGISTER,
}
